import { deleteField } from '@angular/fire/firestore';

interface SharedDoc {
  contextIds?: string[] | null;
  contextIdRights?: Record<string, string> | null;
}

export function hasSharing(doc: SharedDoc | null | undefined): boolean {
  return !!doc?.contextIds?.length
    || !!Object.keys(doc?.contextIdRights ?? {}).length;
}

export function applySharingFieldDeletes(
  map: Record<string, any> | null | undefined,
  previous: SharedDoc | null | undefined,
  next: SharedDoc | null | undefined,
): void {
  if (!map) return;
  // Never shared, or still shared — the ordinary diff already covers both.
  if (!hasSharing(previous) || hasSharing(next)) return;

  map['contextIds'] = deleteField();
  map['contextIdRights'] = deleteField();
}
